import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWG5M8F1 (開票申請單核准沖銷)
// backend/modules/pwg5m8f1/models/models.go
// ============================================================

export interface ReverseCandidate {
  fg160_01: string;      // 申請單號
  fg160_11: string;      // 申請日期
  fg160_15: string;      // 開票對象
  fg160_18: string;      // 客戶代號
  fg160_24: string;      // 單據類別
  fg160_24_label: string; // 單據類別文字
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResultItem {
  row_key: string;
  success: boolean;
  error_message?: string;
  resulting_status_code?: string;
}

export interface ReverseResponse {
  results: ReverseResultItem[];
}

// ============================================================
// API methods
// ============================================================

export const pwg5m8Api = {
  /**
   * Query invoice application candidates eligible for reversal. Candidate
   * set is role-dependent server-side (regular_user sees [E,P], finance_user
   * sees [X,Z] — PWG5M8-DBR-LIST-CANDIDATES), resolved from the caller's own
   * auth context, not a client-supplied parameter.
   */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start_no'] = startNo.trim();
    if (endNo.trim()) params['end_no'] = endNo.trim();
    const res = await apiClient.get('/api/pwg5m8/candidates', { params });
    return res.data;
  },

  /**
   * Execute batch reversal for selected invoice applications.
   * PWG5M8-VAL-REVERSE-CONFIRM-DIALOG (human_approved 2026-07-23): backend
   * rejects any call missing an explicit confirmed:true with 422 + zero DB
   * mutation. Callers must only invoke this after the user has confirmed
   * (e.g. inside a Modal.confirm's onOk), same as pwg5m4f1/pwg5m5f1.
   */
  async reverse(items: string[], confirmed: boolean = true): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwg5m8/reverse', { items, confirmed });
    return res.data;
  },
};
